import * as Sentry from '@sentry/nextjs'

export type ProductImageArea =
  | 'pdp-mobile'
  | 'pdp-tablet'
  | 'pdp-desktop-thumb'
  | 'pdp-desktop-main'
  | 'pdp-unavailable'
  | 'quickview'

type ProductImageOutcome = 'slow' | 'recovered' | 'failed'

type ProductImageIssue = {
  outcome: ProductImageOutcome
  area: ProductImageArea
  primaryUrl: string
  fallbackUrl: string
}

type CaptureContext = {
  level: 'warning'
  tags: Record<string, string>
  extra: Record<string, string>
}

const createProductImageReporter = (
  capture: (message: string, context: CaptureContext) => void,
  limit = 3
): ((issue: ProductImageIssue) => void) => {
  let reported = 0
  return ({ outcome, area, primaryUrl, fallbackUrl }) => {
    if (reported >= limit) {
      return
    }
    reported++
    capture('Product image failed to load', {
      level: 'warning',
      tags: { outcome, area },
      extra: { primaryUrl, fallbackUrl }
    })
  }
}

export const reportProductImageIssue = createProductImageReporter(
  (message, context) => Sentry.captureMessage(message, context)
)
